import { render } from "./App.vue?vue&type=template&id=21a704a5&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=21a704a5&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Github\\Wellen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a704a5"]])

export default __exports__